import { useEffect } from 'react';
import { useBreadcrumbs } from '../providers/breadcrumbs/BreadcrumbContext';

export const useCopyableBreadcrumb = (uid?: string, options?: { enabled?: boolean }) => {
  const { setCopyable } = useBreadcrumbs();

  useEffect(() => {
    if (uid && options?.enabled !== false) {
      setCopyable(uid);
    }
  }, [uid, options?.enabled, setCopyable]);
};
